(function () {
  'use strict';

  var _p = null, _s = {}, _pk = null, _init = false, _mo = null, _curVar = null;
  var KP_CART_FLAG = 'kp_open_cart';

  function getHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function normOpts(options) {
    return (options || []).map(function (o) {
      return (o && typeof o === 'object') ? (o.name || '') : String(o);
    });
  }
  function avail(vars, opts, oi, ov, sel) {
    var t = Object.assign({}, sel); t[opts[oi]] = ov;
    var matches = vars.filter(function (v) { return opts.every(function (n, i) { return v['option' + (i + 1)] === t[n]; }); });
    if (!matches.length) return 'x';
    return matches.some(function (v) { return v.available; }) ? 'ok' : 'out';
  }
  function bestV(vars, opts, sel) {
    return (
      vars.find(function (v) { return opts.every(function (n, i) { return v['option' + (i + 1)] === sel[n]; }); }) ||
      vars.find(function (v) { return v.option1 === sel[opts[0]] && v.available; }) ||
      vars.find(function (v) { return v.available; }) ||
      vars[0]
    );
  }
  var COLORS = {
    blanco:'#ffffff',negro:'#111111',rojo:'#c0392b',mostaza:'#d4a017',
    amarillo:'#f1c40f',azul:'#2980b9',verde:'#27ae60',rosa:'#f48fb1',
    beige:'#f5f0e8',crema:'#fdf6e3',gris:'#9e9e9e',nude:'#e8c9a0',
    cafe:'#795548',marron:'#795548',coral:'#ff6f61',navy:'#1a237e',
    burdeos:'#800020',terracota:'#c0735a',blush:'#f2aea2',
    dorado:'#c9a84c',plateado:'#b0b0b0',naranja:'#e67e22',lila:'#9b59b6'
  };
  function swatchStyle(val, vars, oi) {
    var v = vars.find(function (vr) { return vr['option' + (oi + 1)] === val; });
    if (v && v.featured_image && v.featured_image.src) return 'background-image:url(' + v.featured_image.src + ')';
    var key = val.toLowerCase().replace(/\s+/g, '').normalize('NFD').replace(/[̀-ͯ]/g, '');
    return 'background-color:' + (COLORS[key] || COLORS[val.toLowerCase()] || '#ccc');
  }
  function findSelect() {
    return document.querySelector('select[name="id"]')
      || document.querySelector('[data-pf-type] select')
      || document.querySelector('.pf-variant-select')
      || document.querySelector('.pf-product select');
  }
  function formatMoney(cents) {
    var fmt = window.money_format || '{{amount}}';
    return fmt.replace(/\{\{[^}]+\}\}/, (cents / 100).toFixed(2).replace('.', ','));
  }

  // ---- PageFly ATC button overlay (CSS-based, React-safe) ----
  // Sets data-kp-text on the button. CSS ::after shows it over the native text.
  // isAvail() defaults true so the button shows "Add to cart" even before the fetch.
  function atcText()  { return (window.variantStrings && window.variantStrings.addToCart) || 'Añadir al carrito'; }
  function soldText() { return (window.variantStrings && window.variantStrings.soldOut)   || 'Agotado'; }
  function isAvail()  { return !_curVar || _curVar.available !== false; }

  function applyPFBtnState() {
    var btns = document.querySelectorAll('[data-pf-type^="ProductATC"]');
    if (!btns.length) return;
    var avl = isAvail();
    btns.forEach(function (btn) {
      btn.setAttribute('data-kp-text',  avl ? atcText() : soldText());
      btn.setAttribute('data-kp-avail', avl ? '1' : '0');
    });
  }

  // ---- Picker ----
  function ensureInDom() {
    if (!_pk || document.contains(_pk)) return;
    var select = findSelect();
    if (select && select.parentNode) select.parentNode.insertBefore(_pk, select);
  }
  function hideSelect(select) {
    select.style.cssText = 'display:none!important;position:absolute!important;left:-9999px!important;height:0!important;overflow:hidden!important;';
  }

  function refresh() {
    if (!_p || !_pk) return;
    var opts = normOpts(_p.options), vars = _p.variants;
    var best = bestV(vars, opts, _s);
    if (!best) return;
    opts.forEach(function (n, i) { _s[n] = best['option' + (i + 1)]; });
    _pk.querySelectorAll('[data-oi]').forEach(function (btn) {
      var oi = +btn.getAttribute('data-oi'), ov = btn.getAttribute('data-ov');
      var a = avail(vars, opts, oi, ov, _s);
      btn.classList.toggle('kp-on', _s[opts[oi]] === ov);
      btn.classList.toggle('kp-out', a === 'out');
      btn.classList.toggle('kp-x',   a === 'x');
    });
    _pk.querySelectorAll('[data-kv]').forEach(function (el) {
      el.textContent = _s[opts[+el.getAttribute('data-kv')]];
    });
    _curVar = best;
    applyPFBtnState();
    // Notify PageFly’s hidden select so it updates images/prices
    var pfSel = findSelect();
    if (pfSel) {
      pfSel.value = String(best.id);
      try { pfSel.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }
    document.querySelectorAll('input[name="id"]').forEach(function (inp) { inp.value = String(best.id); });
    if (best.price !== undefined) {
      var pf = formatMoney(best.price);
      ['[data-product-price]','.price__regular .price-item','.price-item--regular','.pf-price .money'].forEach(function (s) {
        document.querySelectorAll(s).forEach(function (el) { if (/\d/.test(el.textContent)) el.innerHTML = pf; });
      });
    }
  }

  function build(select) {
    var opts = normOpts(_p.options), vars = _p.variants;
    var curId = parseInt(select.value, 10);
    var cur = vars.find(function (v) { return v.id === curId; })
      || vars.find(function (v) { return v.available; })
      || vars[0];
    if (cur) opts.forEach(function (n, i) { _s[n] = cur['option' + (i + 1)]; });

    _pk = document.createElement('div');
    _pk.className = 'kp';
    opts.forEach(function (optName, oi) {
      var vals = [], seen = {};
      vars.forEach(function (v) { var x = v['option' + (oi + 1)]; if (!seen[x]) { seen[x] = 1; vals.push(x); } });
      var isSwatch = /colou?r/i.test(optName);
      var g   = document.createElement('div'); g.className = 'kp-g';
      var lbl = document.createElement('div'); lbl.className = 'kp-lbl';
      lbl.textContent = optName + ': ';
      var sp = document.createElement('b'); sp.setAttribute('data-kv', oi);
      sp.textContent = _s[optName] || vals[0];
      lbl.appendChild(sp); g.appendChild(lbl);
      var row = document.createElement('div'); row.className = 'kp-row';
      vals.forEach(function (val) {
        var a   = avail(vars, opts, oi, val, _s);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-oi', oi);
        btn.setAttribute('data-ov', val);
        btn.className = 'kp-btn'
          + (isSwatch ? ' kp-sw' : '')
          + (_s[optName] === val ? ' kp-on' : '')
          + (a === 'out' ? ' kp-out' : '')
          + (a === 'x'   ? ' kp-x'   : '');
        if (isSwatch) {
          btn.setAttribute('style', swatchStyle(val, vars, oi));
          btn.setAttribute('aria-label', val);
          var tip = document.createElement('span'); tip.className = 'kp-tip'; tip.textContent = val;
          btn.appendChild(tip);
        } else { btn.textContent = val; }
        btn.addEventListener('click', function () {
          if (btn.classList.contains('kp-x')) return;
          _s[optName] = val; refresh();
        });
        row.appendChild(btn);
      });
      g.appendChild(row); _pk.appendChild(g);
    });
    select.parentNode.insertBefore(_pk, select);
    hideSelect(select);
    // Start observer to keep picker in DOM if PageFly re-renders
    if (_mo) _mo.disconnect();
    _mo = new MutationObserver(function () { ensureInDom(); applyPFBtnState(); });
    _mo.observe(document.body, { childList: true, subtree: true,
                                  attributes: true, attributeFilter: ['disabled'] });
    if (cur) { _curVar = cur; applyPFBtnState(); }
  }

  function injectCSS() {
    if (document.getElementById('kp-css')) return;
    var s = document.createElement('style'); s.id = 'kp-css';
    s.textContent =
      // PageFly ATC button: ::after overlays native text with ours.
      // position:absolute + background:inherit covers "Agotado" completely.
      // Does NOT use font-size:0 (collapses button on mobile).
      '[data-pf-type^="ProductATC"]{position:relative!important;overflow:hidden!important;pointer-events:all!important;cursor:pointer!important;opacity:1!important;}'
      +'[data-pf-type^="ProductATC"]::after{content:attr(data-kp-text);position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:inherit;border-radius:inherit;color:inherit;font-size:14px;font-weight:500;text-transform:uppercase;letter-spacing:0;pointer-events:none;z-index:2;}'
      +'[data-pf-type^="ProductATC"][data-kp-avail="0"]{opacity:0.6!important;cursor:not-allowed!important;pointer-events:none!important;}'
      // .kp picker
      +'.kp{margin:0 0 14px}.kp-g{margin-bottom:12px}'
      +'.kp-lbl{font-size:11px;text-transform:uppercase;letter-spacing:.08em;color:#888;margin-bottom:8px}.kp-lbl b{color:#111;font-weight:700}'
      +'.kp-row{display:flex;flex-wrap:wrap;gap:6px}'
      +'.kp-btn{appearance:none;-webkit-appearance:none;background:#fff;border:1px solid #ccc;cursor:pointer;font-family:inherit;font-size:13px;min-width:44px;height:40px;padding:0 12px;transition:background .15s,border-color .15s,color .15s;letter-spacing:.02em}'
      +'.kp-btn.kp-on{background:#111;color:#fff;border-color:#111}'
      +'.kp-btn.kp-out{opacity:.45;text-decoration:line-through}.kp-btn.kp-x{opacity:.2;cursor:not-allowed}'
      +'.kp-btn.kp-sw{width:34px;height:34px;min-width:34px;padding:0;border-radius:50%;border:2px solid #e0e0e0;position:relative;background-size:cover!important;background-position:center!important}'
      +'.kp-btn.kp-sw.kp-on{border-color:#111;box-shadow:0 0 0 2px #fff,0 0 0 4px #111}'
      +'.kp-tip{display:none;position:absolute;bottom:calc(100% + 8px);left:50%;transform:translateX(-50%);background:#111;color:#fff;font-size:11px;white-space:nowrap;padding:3px 8px;pointer-events:none;z-index:9999}'
      +'.kp-btn:hover .kp-tip{display:block}';
    document.head.appendChild(s);
  }

  // ---- ATC click intercept (capture phase, before React) ----
  function setupATCIntercept() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pf-type^="ProductATC"]');
      if (!btn) return;
      if (!isAvail()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (btn._kp_adding) return;
      btn._kp_adding = true;
      btn.setAttribute('data-kp-text', 'Añadiendo…');
      var qty = 1;
      var qEl = document.querySelector('input[name="quantity"]:not([disabled])');
      if (qEl && +qEl.value > 0) qty = +qEl.value;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: _curVar.id, quantity: qty })
      })
      .then(function (r) { if (!r.ok) return r.json().then(function (err) { throw err; }); return r.json(); })
      .then(function () {
        btn.setAttribute('data-kp-text', '✓ Añadido');
        try { sessionStorage.setItem(KP_CART_FLAG, '1'); } catch (x) {}
        setTimeout(function () { window.location.reload(); }, 700);
      })
      .catch(function (err) {
        btn._kp_adding = false;
        applyPFBtnState();
        var msg = (err && err.description) ? err.description : 'Error al añadir al carrito';
        if (typeof showWarning === 'function') showWarning(msg);
      });
    }, true);
  }

  // ---- Cart auto-open ----
  function checkAutoOpenCart() {
    try { if (sessionStorage.getItem(KP_CART_FLAG) !== '1') return; sessionStorage.removeItem(KP_CART_FLAG); } catch (e) { return; }
    function tryOpen(n) {
      var ic = document.querySelector('.header__icon--cart') || document.querySelector('[data-open-cart-sidebar]') || document.querySelector('[data-cart-icon]');
      if (ic) { ic.click(); } else if (n < 5) { setTimeout(function () { tryOpen(n + 1); }, 300); }
    }
    if (document.readyState === 'complete') { setTimeout(function () { tryOpen(0); }, 400); }
    else { window.addEventListener('load', function () { setTimeout(function () { tryOpen(0); }, 400); }); }
  }

  // ---- Polling: apply button state every 100ms for 8s ----
  function startPolling() {
    var n = 0;
    var iv = setInterval(function () {
      if (++n > 80) { clearInterval(iv); return; }
      applyPFBtnState();
    }, 100);
  }

  // ---- Init (with retries for slow PageFly render) ----
  function init() {
    if (!window.location.pathname.includes('/products/') || _init) return;
    var select = findSelect();
    if (!select) return;
    _init = true;
    var h = getHandle(); if (!h) return;
    if (_p) { injectCSS(); build(select); return; }
    fetch('/products/' + h + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        _p = data;
        var acc = (data.variants || []).find(function (v) { return v.available; });
        if (acc) _curVar = acc;
        injectCSS(); build(select);
      })
      .catch(function () {});
  }

  // ---- Boot ----
  checkAutoOpenCart();
  injectCSS();        // CSS ready immediately (button overlay + picker styles)
  setupATCIntercept();
  startPolling();     // starts applying button state right away (defaults to available)

  // Picker: tries now, then retries in case PageFly hasn’t rendered its select yet
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  setTimeout(init, 600);
  setTimeout(init, 1800);
  setTimeout(init, 3500);

})();
